import { IonButton, IonContent, IonPage, IonText } from "@ionic/react";
import AnimationContainer from "../components/Animation";

interface Props {
  onDismiss: (confirm: boolean) => () => void;
  title: string;
  subtitle: string;
  icon: any;
  buttonText?: string;
  animation?: string;
}
const GenericInfo: React.FC<Props> = ({
  onDismiss,
  title,
  subtitle,
  icon,
  buttonText,
  animation
}) => {
  // console.log("icon", icon);
  return (
    <IonPage>
      <IonContent fullscreen className="content-transparent">
        <div className="flex flex-col h-full justify-center items-center">
          <AnimationContainer animationName={animation || "chartAnimation"} />
          <div className="font-bold text-2xl my-6 text-white text-center">
            {title}
          </div>
          <p className="mx-6 text-primary-20 w-2/3 px-2 pb-6 text-center">
            {subtitle}
          </p>
          <IonButton
            expand="block"
            color="primary"
            type="submit"
            className="w-2/3 font-semibold text-lg"
            onClick={() => onDismiss(true)}
          >
            {buttonText || "Let's go!"}
          </IonButton>
          <div className="text-center mt-4">
            <IonText
              color="dark"
              className="text-lg text-primary-20 cursor-pointer"
              onClick={() => onDismiss(false)}
            >
              Cancel
            </IonText>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default GenericInfo;
